import { Avatar, FormHelperText, Grid, InputAdornment } from "@mui/material"
import AppDialog from "../../../components/Common/AppDialog"
import CustomButton from "../../../components/Form/CustomButton"
import { Icon } from "@iconify/react/dist/iconify.js"
import CustomTextField from "../../../components/Form/CustomTextField"
import { useRef } from "react"
import Helpers from "../../../helpers/helpers"

const EditProfileModal = ({ open, close, submit, formObj, setFormObj, error }) => {
    const fileInputRef = useRef(null);

    const onChangeFile = (file) => {
        // if (Helpers.isFileSizeValid(file)) {
        Helpers.getPreviewBase64(file, (result) => {
            setFormObj({ ...formObj, pfp_base64: result });
        });
        // }
        // Clear the upload file value
        fileInputRef.current.value = null;
    };

    const handleFormObjChange = (key, value) => {
        setFormObj({ ...formObj, [key]: value });
    }

    return (
        <AppDialog
            open={open}
            title={"Edit profile"}
            close={() => close()}
            positiveTitle={'Save changes'}
            positivePress={() => submit()}
            cancelButton={true}
            width={'40%'}
        >
            <div className="mb-2">
                Profile image
                {error?.profile_photo && <FormHelperText className='d-flex align-items-center m-0' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.profile_photo || ""}</FormHelperText>}
            </div>
            <Grid container spacing={2}>
                <Grid item sm={12} className="d-flex align-items-center">
                    <Avatar src={formObj?.pfp_base64 || ''} style={{ height: 64, width: 64 }} />
                    <CustomButton
                        title={<><Icon icon={'mdi:tray-upload'} style={{ marginRight: 5 }} /> Upload Image</>}
                        backgroundColor={'white'}
                        borderStyle={'1px solid #594A4E'}
                        textColor={'#594A4E'}
                        press={() => document.getElementById(`new-upload-file`).click()}
                        marginLeft={20}
                        marginRight={10}
                    />
                    {
                        formObj?.pfp_base64 &&
                        <CustomButton
                            title={'Remove'}
                            backgroundColor={'#F9F9F9'}
                            borderStyle={'1px solid #F9F9F9'}
                            textColor={'#808588'}
                            press={() => handleFormObjChange('pfp_base64', '')}
                        />
                    }
                </Grid>
                <Grid item sm={12}>
                    <CustomTextField
                        title={'Name'}
                        placeholder={'Name'}
                        values={formObj?.name}
                        onChange={(e) => handleFormObjChange('name', e)}
                        error={error?.name}
                    />
                </Grid>
                <Grid item sm={12}>
                    <CustomTextField
                        title={'Email Address'}
                        placeholder={'Email Address'}
                        values={formObj?.email}
                        onChange={(e) => handleFormObjChange('email', e)}
                        disabled={true}
                    />
                </Grid>
                <Grid item sm={12}>
                    <CustomTextField
                        title={'Phone Number'}
                        prefix="+60"
                        error={error?.phone}
                        values={formObj?.phone}
                        onChange={(e) => handleFormObjChange('phone', e)}
                        placeholder="Phone Number"
                        type={'number'}
                        InputProps={{
                            startAdornment: <InputAdornment position="start"><div style={{ borderRight: '1px solid #E6E6E6', paddingInline: 10, color: '#101010' }}>+60</div></InputAdornment>,
                        }}
                    />
                </Grid>
            </Grid>
            <input
                type="file"
                id={`new-upload-file`}
                ref={fileInputRef}
                style={{ display: 'none' }}
                accept="image/png, image/jpeg, image/jpg"
                onChange={(e) => onChangeFile(e.target.files[0])}
            />
        </AppDialog>
    )
}
export default EditProfileModal;